import * as React from 'react';
import { IStatusMessage } from '../../../Models/IStatusMessage';
import { PasswordChangeView } from './PasswordChangeView';
import * as Services from '../../../Services/Services';
import { IProfileApi } from '../../../Services/API/Profile/IProfileApi';
import { MessageBarType } from '@fluentui/react';

interface IPasswordChangeProps {

}

export const PasswordChange: React.FunctionComponent<IPasswordChangeProps> = (props) => {

    const [newPassword, setNewPassword] = React.useState("");
    const [confirmPassword, setConfirmPassword] = React.useState("");
    const [oldPassword, setOldPassword] = React.useState("");

    const [isLoading, setIsLoading] = React.useState(false);
    const [statusMessage, setStatusMessage] = React.useState<IStatusMessage>()
    const [canSave, setCanSave] = React.useState(false);

    React.useEffect(() => {
        setCanSave(oldPassword !== "" && newPassword!=="" && newPassword === confirmPassword);
    }, [newPassword, confirmPassword]);

    const changePassword = async () => {
        setIsLoading(true);
        setStatusMessage(undefined);
        const profileApi = Services.ServicesProvider.GetService<IProfileApi>(Services.ProfileApi);
        const profile = await profileApi.changePassword(oldPassword, newPassword, confirmPassword);
        if (profile.isSuccess) {
            setStatusMessage({ message: profile.message, type: MessageBarType.success });
        }
        else {
            setStatusMessage({ message: profile.message, type: MessageBarType.error });
        }
        setIsLoading(false);
    }

    return (<PasswordChangeView
        width={400}
        canSave={canSave}
        isLoading={isLoading}
        statusMessage={statusMessage}
        newPassword={newPassword}
        onNewPassword={setNewPassword}
        confirmPassword={confirmPassword}
        onConfirmPassword={setConfirmPassword}
        oldPassword={oldPassword}
        onOldPassword={setOldPassword}
        changePassword={changePassword}
    />)
}
